import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { fetchRemittanceSources, RemittanceSource } from '../services/remittanceCalculatorApi';
import { DESTINATION, liveCorridors } from './corridorList';
import LazyGlobe from './LazyGlobe';

// WU-REACH: where you can send from and to today, beside the globe. The "Send from" chips are the corridors the
// live calculator catalogue accepts (before it answers, or if it fails, the confirmed list). The globe's routes
// are illustrative and say so in its caption; this panel is the real availability.
const ReachPanel: React.FC = () => {
  const { t } = useTranslation();
  const [sources, setSources] = useState<RemittanceSource[] | null>(null);

  useEffect(() => {
    const controller = new AbortController();
    fetchRemittanceSources(controller.signal)
      .then((rows) => setSources(rows))
      .catch(() => setSources(null));
    return () => controller.abort();
  }, []);

  return (
    <div className="reach-panel">
      <div className="reach-availability">
        <p className="reach-availability__label">{t('reach.sendFrom')}</p>
        <ul className="reach-chips">
          {liveCorridors(sources).map((corridor) => (
            <li key={corridor.id} className="reach-chip">
              <img src={corridor.flag} alt="" width={24} height={24} />
              {t(`reach.from.${corridor.id}`)}
            </li>
          ))}
        </ul>

        <p className="reach-availability__label">{t('reach.receiveIn')}</p>
        <div className="reach-destination">
          <img className="reach-destination__flag" src={DESTINATION.flag} alt="" width={32} height={32} />
          <div className="reach-destination__text">
            <span className="reach-status">
              <span className="reach-status__dot" aria-hidden="true" />
              {t('reach.to.ug')}
            </span>
            <p className="reach-destination__payout">{t('reach.to.payout')}</p>
          </div>
        </div>
      </div>

      <figure className="reach-globe">
        <div className="reach-globe__disc">
          <LazyGlobe />
        </div>
        <figcaption className="reach-globe__caption">{t('reach.globeCaption')}</figcaption>
      </figure>
    </div>
  );
};

export default ReachPanel;
